// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { screen } from "@bg/XDL/Helpers";
import { xBaseTheme } from "@bg/XDL/types";
import { color } from "@bg/XDL/Utilities";
import DataTablePresentationPropsDefault from "@insite/mobius/DataTable/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

const stickyMode = css`
    ${screen("lte", "md")`
        position: sticky;
        left: 0;
        z-index: 2;
        background-clip: padding-box;
        box-shadow: 0 2px 9px -2px ${color("common.black.main", 0.12)};
    `}
`;

export default {
    defaultProps: {
        ...DataTablePresentationPropsDefault,
        cssOverrides: {
            header: css`
                background: ${getColor("common.ui4")};
                width: auto;
                text-align: left;
                text-transform: uppercase;
                border: 0;
                height: 38px;

                span {
                    color: ${getColor("text.main")};
                    text-transform: uppercase;
                    font-size: 13px;
                    font-weight: 500;
                    letter-spacing: 0.2px;
                    line-height: 22px;
                }

                > button {
                    justify-content: flex-start;

                    span:last-child {
                        display: none !important;
                    }
                }
            `,
            body: css`
                a span {
                    font-size: 15px;
                    line-height: 18px;
                }
            `,
            head: css`
                th:first-child {
                    ${stickyMode}
                }
            `,
            cell: css`
                padding: 22px 12px;
                border-bottom-color: ${getColor("common.ui4")};
                background-color: ${getColor("common.white")};
                &:first-child {
                    ${stickyMode}
                }
            `,
        },
        cellTypographyProps: {
            size: 15,
        },
    },
} as xBaseTheme["dataTable"];
